import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

const DESKTOP_MQ = '(min-width: 1024px)';
const DESKTOP_COLUMNS = 3;

export default function initFeaturedLinks() {
  const blocks = document.querySelectorAll('.aviatrix-block--featured-links');

  blocks.forEach(block => {
    const viewport = block.querySelector('.featured-links__viewport');
    const track    = block.querySelector('.featured-links__track');
    const template = block.querySelector('.featured-links__controls-template');
    if (!viewport || !track) return;

    if (block.dataset.featuredLinks && !viewport.id) {
      viewport.id = block.dataset.featuredLinks;
    }

    const tileCount = track.querySelectorAll(':scope > .featured-link').length;
    if (!tileCount) return;

    const slidesOnDesktop = tileCount > DESKTOP_COLUMNS;
    block.classList.toggle('is-desktop-slider', slidesOnDesktop);

    const mq = window.matchMedia(DESKTOP_MQ);
    let swiper = null;
    let controls = null;

    const shouldSlide = () => !mq.matches || slidesOnDesktop;

    const showControls = show => {
      if (controls) controls.hidden = !show;
    };

    const create = () => {
      if (swiper) return;

      controls = template ? template.content.firstElementChild.cloneNode(true) : null;
      if (controls) viewport.after(controls);

      swiper = new Swiper(viewport, {
        modules: [Navigation, A11y, Keyboard],
        wrapperClass: 'featured-links__track',
        slideClass: 'featured-link',
        slidesPerView: 1.4,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        watchOverflow: true,
        watchSlidesProgress: true,
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: {
          prevSlideMessage: 'Previous tile',
          nextSlideMessage: 'Next tile',
          firstSlideMessage: 'This is the first tile',
          lastSlideMessage: 'This is the last tile',
        },
        navigation: {
          prevEl: controls && controls.querySelector('.featured-links__nav--prev'),
          nextEl: controls && controls.querySelector('.featured-links__nav--next'),
          disabledClass: 'swiper-button-disabled',
        },
        on: {
          lock: () => showControls(false),
          unlock: () => showControls(true),
        },
        breakpoints: {
          500: { slidesPerView: 2, spaceBetween: 16 },
          1024: {
            slidesPerView: DESKTOP_COLUMNS,
            spaceBetween: 16,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      });

      showControls(!swiper.isLocked);
    };

    const destroy = () => {
      if (!swiper) return;
      swiper.destroy(true, true);
      swiper = null;
      if (controls) controls.remove();
      controls = null;
    };

    const sync = () => (shouldSlide() ? create() : destroy());

    sync();
    mq.addEventListener('change', sync);
  });
}
